import { Component, OnInit, ChangeDetectionStrategy, Input } from '@angular/core';

@Component({
    selector: 'shared-forms-columns',
    templateUrl: './forms-columns.shared.component.html',
    styleUrls: ['./forms-columns.shared.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class FormsColumnsComponent {
    @Input() public align: 'space-between' | 'start' | 'end' | 'center' = 'space-between';
    @Input() public itemsMargin: boolean = false;
    @Input() public mobileFull: boolean = false;
}
